module.exports = __webpack_public_path__ + "img/157.d27cfb8e.jpg";